import { setPhysicalSession } from "../utils/physicalApi"
import { App } from "antd"
import { createContext, ReactNode, useContext, useEffect, useLayoutEffect, useMemo } from "react"
import { useHistory } from "react-router-dom"
import type { ICloudUser } from "../types"
import { deleteLocalStorageCloudApiUser } from "../utils/cloudApiV2"
import { setRegulatorySession } from "../utils/regulatoryApi"
import { useSyncronizationContext } from "./syncronizationProvider"
const Context = createContext<{ user: ICloudUser | null; sessionKey: string }>({
  user: null,
  sessionKey: "",
})
export function RegulatoryProvider({ children }: { children: ReactNode }) {
  const { currentUser, currentEnterprise, externallySetCurrentUser } = useSyncronizationContext()
  const history = useHistory()
  useEffect(() => {
    const expire = () => {
      setRegulatorySession(null)
      setPhysicalSession(null)
      deleteLocalStorageCloudApiUser()
      externallySetCurrentUser(null)
      history.replace("/login")
    }
    window.addEventListener("cloud-session-expired", expire)
    return () => window.removeEventListener("cloud-session-expired", expire)
  }, [history, externallySetCurrentUser])
  const sessionKey = `${currentUser?.UUID ?? ""}/${currentEnterprise?.UUID ?? ""}`
  useLayoutEffect(() => {
    setRegulatorySession(sessionKey)
    setPhysicalSession(sessionKey)
    return () => {
      setRegulatorySession(null)
      setPhysicalSession(null)
    }
  }, [sessionKey])
  const value = useMemo(() => ({ user: currentUser, sessionKey }), [currentUser, sessionKey])
  return (
    <Context.Provider value={value}>
      <App>{children}</App>
    </Context.Provider>
  )
}
export const useRegulatorySession = () => useContext(Context)
